// extracted by mini-css-extract-plugin
module.exports = {"info":"_3k0eQ1Y","typeInfo":"_37eWHfb","typeConfirmation":"_1zXXRjw","typeError":"_3uV6qqN","typeWarning":"_39jif9x"};